<template>
    <div :class="messageClass">
        <common-page-copy size="minor">
            <slot></slot>
        </common-page-copy>
    </div>
</template>

<script>
    export default {
        props: {
            type: { type: String, required: true },
        },

        computed: {
            messageClass() {
                return {
                    message: true,
                    [`message--type-${this.type}`]: true,
                }
            },
        },
    }
</script>
